import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import { getStorage, setStorage } from "@/utils/storage";

Vue.use(Vuex);
// https://webpack.js.org/guides/dependency-management/#requirecontext
const modulesFiles = require.context("./modules", true, /\.js$/);

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, "$1");
  const value = modulesFiles(modulePath);
  modules[moduleName] = value.default;
  return modules;
}, {});

let lifeData = getStorage("lifeData") || {};
// 需要永久存储，且下次APP启动需要取出的，在state中的变量名
let saveStateKeys = [
  "vuex_user",
  "vuex_token",
  "vuex_authorities",
];
// 保存变量到本地存储中
const saveLifeData = function(key, value) {
  // 判断变量名是否在需要存储的数组中
  if (saveStateKeys.indexOf(key) != -1) {
    // 获取本地存储的lifeData对象，将变量添加到对象中
    let tmp = getStorage("lifeData") || {};
    // 第一次打开APP，不存在lifeData变量，故放一个{}空对象
    tmp[key] = value;
    // 执行这一步后，所有需要存储的变量，都挂载在本地的lifeData对象中
    setStorage("lifeData", tmp);
  }
};

const store = new Vuex.Store({
  modules,
  getters,
  state: {
    vuex_user: lifeData.vuex_user
      ? lifeData.vuex_user
      : { name: "", roles: [],userType:1 },
    vuex_token: lifeData.vuex_token || "",
    vuex_authorities: lifeData.vuex_authorities || [],
    vuex_version: "1.0.0",
    pageNavs: {
      title: "",
      list: []
    },
    page: {
      title: "工作",
      list: []
    }
  },
  mutations: {
    $uStore(state, { module, name, value }) {
      // 判断是否多层级调用，state中为对象存在的情况，诸如user.info.score = 1
      let nameArr = name.split(".");
      let saveKey = "";
      let len = nameArr.length;
      if (module) state = state[module];
      if (len >= 2) {
        let obj = state[nameArr[0]];
        for (let i = 1; i < len - 1; i++) {
          obj = obj[nameArr[i]];
        }
        obj[nameArr[len - 1]] = value;
        saveKey = nameArr[0];
      } else {
        // 单层级变量，在state就是一个普通变量的情况
        state[name] = value;
        saveKey = name;
      }
      // 保存变量到本地，见顶部函数定义
      saveLifeData(saveKey, state[saveKey]);
    }
  },
  actions: {}
});

export default store;
